angular.module('dnecom.component.currency')
    .service('CurrencyRates', ["$http", "$cookies", "$q", function($http, $cookies, $q) {
        var initialCurrencyCode = _.get(window, 'ies.store.currency.code');
        var storeCurrency = _.get(window, 'ies.store.currency.storeCode');
        var initialChosenCurrencyRate = _.get(window, 'ies.store.currency.rate');
        var initialCountryCode = _.get(window, 'ies.store.countryCode');
        if (initialCountryCode) {
            $cookies.put('store_country', initialCountryCode, {
                path: '/'
            });
        }
        var currentPromise = null;
        var currentCurrencyCode = initialCurrencyCode;

        if (initialChosenCurrencyRate) {
            currentPromise = $q.resolve({ code: initialCurrencyCode, rate: initialChosenCurrencyRate });
        }

        return {
            setCurrentCurrency: function (code) {
                return $cookies.put('store_currency', code, {
                    path: '/'
                });
            },

            fetchInitialCurrency: function() {
                return initialCurrencyCode;
            },

            fetchInitialRate: function() {
                return initialChosenCurrencyRate;
            },

            fetchCurrentCurrency: function () {
                return $cookies.get('store_currency') || initialCurrencyCode;
            },

            fetchStoreCurrency: function () {
                return storeCurrency;
            },

            fetchCurrentRate: function(currencyCode) {
                currencyCode = currencyCode || this.fetchCurrentCurrency();

                if (currentCurrencyCode === currencyCode) {
                    return currentPromise;
                }

                var deferred = $q.defer();

                currentCurrencyCode = currencyCode;
                currentPromise = deferred.promise;

                $http.get(
                    Routing.generate(
                        'stores_fe_api_currencies_rate', 
                        { code: currentCurrencyCode }
                    )
                ).then(function(response) {
                    deferred.resolve({ code: currencyCode, rate: response.data });
                }, function () {
                    deferred.reject("Server error.");
                });

                return currentPromise;
            }
        }
    }]);
